import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import finRatings from "../../../../src/data/articles/cube-prospective-final-fantasy/fin-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  finRatings,
  ProspectiveIntro,
  React
};